import { useTranslation } from 'react-i18next';
import { PasskeyLoginButton } from '@f2m3/shared-frontend-ui';
import { usePasskeyLogin } from '../../api/queryHooks/mfa';
import OrDivider from './OrDivider';

// Passwordless entry point. WebAuthn is a DOM concern, so feature-detection lives
// here (not in the portable shared component). Shown on the first login screen
// because passwordless resolves the account from the request origin — no email
// needed. On success the newToken callback stores the token and the Login page's
// redirect effect navigates away.
const PasskeyLoginEntry = () => {
  const { t } = useTranslation();
  const passkeyLogin = usePasskeyLogin();

  const supported = typeof window !== 'undefined' && 'PublicKeyCredential' in window;
  if (!supported) return null;

  return (
    <>
      <PasskeyLoginButton
        label={t('login.passkey_button')}
        className="is-primary"
        isPending={passkeyLogin.isPending}
        onClick={() => passkeyLogin.mutate()}
      />
      <OrDivider />
    </>
  );
};

export default PasskeyLoginEntry;
